"use client";

import { NormalText } from "@/components/text/NormalText";
import { DemoBarOption, DemoOption } from "@/types/types";
import { cn } from "@/utils/cn";

export function BarOption({
  option,
  chosen,
  setChosenOption,
}: {
  option: DemoBarOption;
  chosen: boolean;
  setChosenOption: (newOption: DemoOption) => void;
}) {
  return (
    <li className="w-full">
      <button
        onClick={() => setChosenOption(option.value)}
        className="group flex w-full flex-col items-center pt-2"
      >
        <option.icon
          className={cn(
            chosen ? "text-primary" : "text-gray-900 group-hover:text-primary",
            "h-6 w-6 shrink-0 transition-colors"
          )}
        />
        <NormalText
          elementType="span"
          className={cn(
            chosen ? "text-primary" : "text-gray-900 group-hover:text-primary",
            "transition-colors"
          )}
        >
          <span className="hidden md:block">{option.name}</span>
          <span className="block md:hidden">{option.mobileName}</span>
        </NormalText>

        {chosen && (
          <div className="mt-1 h-[3px] w-full rounded-full bg-primary" />
        )}
      </button>
    </li>
  );
}
